import { render, staticRenderFns } from "./MessageVisualization.vue?vue&type=template&id=03c56054&"
import script from "./MessageVisualization.vue?vue&type=script&lang=js&"
export * from "./MessageVisualization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports